export enum VisitType {
  Schedule = 1,
  Callback,
}
